import { useTranslation } from 'react-i18next'

import { AllIcons } from 'shared/ui/app-icon/types'
import { PaymentType } from 'shared/ui/payment-type'
import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

export const MplusLoading = () => {
  const { t } = useTranslation()

  return (
    <div className={s.container}>
      <div className={s.content}>
        <PaymentType
          isActive
          icon={AllIcons.CASH}
          title={t('mplus.pay_current')}
          subTitle={t('mplus.with_trans_mbank')}
        />
      </div>

      <div className={s.skelet}>
        <Skeleton
          borderRadius={16}
          height="100%"
          width="100%"
        />
      </div>
    </div>
  )
}
